/* This renders a Donation Card

   Hassaan Ali Wattoo 
*/ 

import React from 'react';

class DonateCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            year: this.props.year, 
            headline: this.props.headline,
            authorName: this.props.authorName,
            authorPosition: this.props.authorPosition,
            logo: this.props.logo,
            isColor: this.props.color,
            theme: this.props.theme,
        }
    }

    render() {
        return (
            <div className={`row donate-card`}>
                <div className={`donate-text six columns`}>
                    <div className="donate-heading">
                        THE FIRST-EVER COLLABORATION BETWEEN 
                        THE MICHIGAN DAILY AND THE LANTERN.
                    </div>
                    <div className="donate-sub-heading">
                    It wouldn't be a rivalry without a competition.<br/><br/>
                    Help The Daily defeat The Lantern in our fundraising challenge
                    </div>
                </div>
                <div className={`donate-text donate-buttons six columns`}>
                    <button 
                        onClick={() => window.location.href='https://charity.gofundme.com/o/en/campaign/michigan-daily-rivalry-challenge'}
                        className="donate-button"
                    >
                        CLICK TO DONATE
                    </button>
                    <div style={{marginLeft: 0,}}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/tmd-logo-black.png`}
                        className="donate-logo"
                        alt="Newspaper Logo"
                    />
                    </div>
                </div>
            </div>      
        );
    }
        
    
}

export default DonateCard;